import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import { RequestPublic as RequestPublicGrid } from '../../components/grids/RequestGrid';
import { publicUrlHelpLogged } from '../../CroUtils';

class Requests extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Žádosti o nahlédnutí na neveřejné oznámení' }]);
  }

  onAdd = () => {
    this.props.push(`${publicUrlHelpLogged(this.props.auth)}/zadosti/form`);
  }

  onEdit = ({ id }) => {
    this.props.push(`${publicUrlHelpLogged(this.props.auth)}/zadosti/form/${id}`);
  }

  render() {
    return (
      <RequestPublicGrid
        gridName="requestsGrid_public"
        onRowClick={this.onEdit}
        url={`${this.props.auth.startUrl}/api/zadosti`}
        adding={false}
        onAdd={this.onAdd}
      />
    );
  }
}

export default connect(null, { breadcrumbs, push })(Requests);
